import React, { useState, useEffect } from "react";
import {
  MDBBtn,
  MDBRow,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
} from "mdb-react-ui-kit";
import axios from "axios";
import TextField from "@mui/material/TextField";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import InputMask from "react-input-mask";
import { Link } from "react-router-dom";
//
import { validate } from "../components/login/validate";
// config
import configData from "../config/config.json";
// components
import MetaTagsBusinessOwners from "../components/meta-tags-seo/MetaTagsBusinessOwners";
import RegisterBusiness from "./RegisterBusiness";
// img
import imgg from "../images/register-business/07.png";
import target from "../images/register-business/target.png";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const RegisterBusinessStep6 = (props) => {
  const formatChar = {
    0: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]",
  };

  const [render, setRender] = useState(false);
  const [value, setValue] = useState("");
  const [showSiteInfo, setShowSiteInfo] = useState(false);

  const [disable, setDisable] = useState(false);
  const [disableInfo, setDisableInfo] = useState(false);

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  // show modal
  const [centredModal, setCentredModal] = useState(false);

  const [errorPhone, seterrorPhone] = useState("");

  const [data, setData] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
  });

  const handleChange = (event) => {
    setValue(event.target.value);
    localStorage.setItem("step8-back-data", JSON.stringify(event.target.value)); //set local
  };

  const inputChangeHandler = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
    if (event.target.name == "phone") {
      var num = event.target.value.replace(/\D/g, "").length;
      if (num >= 10) {
        seterrorPhone("");
      } else {
        seterrorPhone("شماره تماس را صحیح وارد کنید.");
      }
    }
  };

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "register-business-step8",
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else {
      // api for meta tags
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });

      // api to check and get data
      axios
        .get(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/sitedesign-profile`,
          {
            headers: {
              ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
              LangId: 1,
              Authorization: "Bearer " + getCookie("token"),
            },
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            let stepStatus = response.data.data.stepStatus;
            let data = response.data.data;

            // check user is registered or not
            if (!stepStatus.isRegistered) {
              props.history.push({
                pathname: "/signup",
              });
            }
            // check the business steps are completed or not
            else if (stepStatus.isComplete) {
              props.history.push({
                pathname: "/business-dashboard",
              });
            }
            // check the business step number -- comment for step 1
            else if (stepStatus.regStep < 8) {
              props.history.push({
                pathname: `/register-business-step${stepStatus.regStep}`,
              });
            } else {
              // set data to states
              if (JSON.parse(localStorage.getItem("step8-back-data-site"))) {
                setData(
                  JSON.parse(localStorage.getItem("step8-back-data-site"))
                );
              }

              if (JSON.parse(localStorage.getItem("step8-back-data"))) {
                const item = JSON.parse(
                  localStorage.getItem("step8-back-data")
                );
                setValue(item);
              }
            }

            setRender(true);
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }
  }, []);

  // validation
  useEffect(() => {
    setErrors(validate(data, "requestSite"));
  }, [data, touched]);

  // submit step8
  const submitHandler = () => {
    setDisable(true);
    axios
      .post(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/sitedesign`,
        {
          bId: getCookie("BizId"),
          siteDesign: value ? parseInt(value) : 0,
        },
        {
          headers: {
            ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
            LangId: 1,
            Authorization: "Bearer " + getCookie("token"),
          },
        }
      )
      .then((response) => {
        setDisable(false);
        if (response.data.isSuccess) {
          // success

          // api for sending email to business owner
          axios
            .post(
              configData.API_DOMAIN + "/api/v1/Businesses/email",
              {
                bId: getCookie("BizId"),
              },
              {
                headers: {
                  ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
                  LangId: 1,
                  Authorization: "Bearer " + getCookie("token"),
                },
              }
            )
            .then((response) => {})
            .catch((error) => {});

          if (value == 3) {
            setShowSiteInfo(true);
          } else {
            // Get the item you want to keep from local storage
            const itemToKeep = JSON.parse(localStorage.getItem("OwnerDetail"));
            const itemToKeep2 = JSON.parse(localStorage.getItem("phonestd"));
            // Clear all local storage
            localStorage.clear();
            // Put back the item you want to keep in local storage
            if (itemToKeep) {
              localStorage.setItem("OwnerDetail", JSON.stringify(itemToKeep));
            }
            if (itemToKeep2) {
              localStorage.setItem("phonestd", JSON.stringify(itemToKeep2));
            }

            props.history.push({
              pathname: "/business-dashboard",
            });
          }
        }
      })
      .catch((error) => {
        setDisable(false);

        // alert(error);
      });
  };

  // sabt handler
  const siteInfoHandler = (event) => {
    event.preventDefault(event);

    if (!Object.keys(errors).length && errorPhone == "") {
      setDisableInfo(true);

      axios
        .post(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/sitedesign-profile`,
          {
            bId: getCookie("BizId"),
            firstname: data.firstname,
            lastname: data.lastname,
            phone: data.phone.replace(/\D/g, ""),
            email: data.email,
          },
          {
            headers: {
              ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
              LangId: 1,
              Authorization: "Bearer " + getCookie("token"),
            },
          }
        )
        .then((response) => {
          setDisableInfo(false);
          if (response.data.isSuccess) {
            // success
            // toggleShow();
            setCentredModal(true);
          }
        })
        .catch((error) => {
          // alert(error);
        });
    } else {
      setTouched({
        firstname: true,
        lastname: true,
        phone: true,
        email: true,
      });
    }
  };

  // modal submit
  const toggleShow = () => {
    // if (
    //   JSON.parse(localStorage.getItem("SelectedOwner")) &&
    //   JSON.parse(localStorage.getItem("SelectedOwner")) == 3
    // ) {
    //   window.location.href = configData.SITE_URL;
    //   // localStorage.clear();
    // } else {
    // Get the item you want to keep from local storage
    const itemToKeep = JSON.parse(localStorage.getItem("OwnerDetail"));
    const itemToKeep2 = JSON.parse(localStorage.getItem("phonestd"));
    // Clear all local storage
    localStorage.clear();
    // Put back the item you want to keep in local storage
    if (itemToKeep) {
      localStorage.setItem("OwnerDetail", JSON.stringify(itemToKeep));
    }
    if (itemToKeep2) {
      localStorage.setItem("phonestd", JSON.stringify(itemToKeep2));
    }
    props.history.push({
      pathname: "/business-dashboard",
    });
    // }
    setCentredModal(!centredModal);
  };

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return (
    <>
      {render ? (
        <>
          {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

          <RegisterBusiness />
          <div>
            <MDBRow className="mx-0">
              <div className="col-12 col-md-8 register-business-padd">
                {showSiteInfo ? (
                  <div className="register-steps-right rightt">
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <h1 className="rb-step6-tit4 color-242b2e mb-2">
                          برای ارتباط با بخش طراحی وبسایت، لطفا اطلاعات زیر را
                          وارد کنید.
                        </h1>
                        <h2 className="rb-step1-tit2 text-md-end text-center">
                          همکاران ما در اولین فرصت با شما تماس خواهند گرفت.
                        </h2>
                        <div className="d-md-flex">
                          <div className="mb-3 ms-md-3">
                            <TextField
                              // dir="ltr"
                              type="text"
                              name="firstname"
                              value={data.firstname}
                              onChange={inputChangeHandler}
                              id="outlined-basic"
                              label="نام"
                              variant="outlined"
                              className={
                                errors.firstname && touched.firstname
                                  ? "label-field-more7 custom-text-field custom-text-field-contact mb-0 width20vw custom-text-field-error"
                                  : "label-field-more7 custom-text-field custom-text-field-contact mb-0 width20vw "
                              }
                            />
                            {errors.firstname && touched.firstname && (
                              <span className="input-error me-1">
                                {errors.firstname}
                              </span>
                            )}
                          </div>

                          <div className="mb-3">
                            <TextField
                              // dir="ltr"
                              type="text"
                              name="lastname"
                              value={data.lastname}
                              onChange={inputChangeHandler}
                              id="outlined-basic"
                              label="نام خانوادگی"
                              variant="outlined"
                              className={
                                errors.lastname && touched.lastname
                                  ? "label-field-more7 custom-text-field custom-text-field-contact mb-0 width20vw custom-text-field-error"
                                  : "label-field-more7 custom-text-field custom-text-field-contact mb-0 width20vw"
                              }
                            />
                            {errors.lastname && touched.lastname && (
                              <span className="input-error me-1">
                                {errors.lastname}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 text-md-end">
                          <InputMask
                            formatChars={formatChar}
                            mask={JSON.parse(localStorage.getItem("phonestd"))}
                            // maskChar={null}
                            value={data.phone}
                            onChange={inputChangeHandler}
                          >
                            {(inputProps) => (
                              <TextField
                                dir="ltr"
                                type="text"
                                name="phone"
                                // value={data.phone}
                                onChange={inputChangeHandler}
                                id="outlined-basic"
                                label="شماره تماس"
                                variant="outlined"
                                className={
                                  (errors.phone && touched.phone) ||
                                  errorPhone != ""
                                    ? "font-family-en label-field-more7 custom-text-field custom-text-field-contact mb-0 custom-text-field-error"
                                    : "font-family-en label-field-more7 custom-text-field custom-text-field-contact mb-0 "
                                }
                                {...inputProps}
                              />
                            )}
                          </InputMask>
                          {errors.phone && touched.phone && (
                            <span className="input-error me-1">
                              {errors.phone}
                            </span>
                          )}
                          {!(errors.phone && touched.phone) &&
                            errorPhone != "" && (
                              <span className="input-error me-1">
                                {errorPhone}
                              </span>
                            )}
                        </div>
                        <div className="mb-3 text-md-end">
                          <TextField
                            dir="ltr"
                            type="text"
                            name="email"
                            value={data.email}
                            onChange={inputChangeHandler}
                            id="outlined-basic"
                            label="ایمیل"
                            variant="outlined"
                            className={
                              errors.email && touched.email
                                ? "label-field-more7 custom-text-field custom-text-field-contact mb-0 custom-text-field-error font-family-en"
                                : "label-field-more7 custom-text-field custom-text-field-contact mb-0 font-family-en"
                            }
                          />
                          {errors.email && touched.email && (
                            <span className="input-error me-1">
                              {errors.email}
                            </span>
                          )}
                        </div>
                        <div className="rb-steps-btns rb-steps-btns-site  position-initial mt-md-5 pt-md-4">
                          <Link
                            onClick={() => {
                              setShowSiteInfo(false);
                              localStorage.setItem(
                                "step8-back-data-site",
                                JSON.stringify(data)
                              ); //set step8 site loocal storage
                            }}
                            className="rb-steps-btn1 hov-shadow"
                          >
                            بازگشت
                          </Link>
                          <MDBBtn
                            disabled={disableInfo}
                            className="rb-steps-btn2 hov-shadow"
                            onClick={siteInfoHandler}
                          >
                            ثبت
                          </MDBBtn>
                        </div>
                        {/* </div> */}
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                ) : (
                  <div className="register-steps-right centerr">
                    <img className="rb-step6-img" src={target} alt="" />
                    <h1 className="rb-step6-tit1">
                      کسب‌وکار با موفقیت ثبت شد و پس از تایید در وبسایت گیشنیز
                      منتشر خواهد شد.
                    </h1>
                    <h2 className="rb-step6-tit2">
                      آیا نیاز دارید یک وبسایت برای کسب‌وکار شما طراحی شود؟
                    </h2>
                    <h3 className="rb-step6-tit3">
                      داشتن وبسایت به بیشتر دیده شدن شما در گوگل و جذب مشتری
                      بیشتر کمک می‌کند.
                    </h3>

                    <div dir="rtl" className="rbtns-s1-box">
                      <div>
                        <label
                          className="container-rbtn-s1 rbtn-s6"
                          onChange={handleChange}
                        >
                          <input
                            type="radio"
                            name="radio"
                            value="1"
                            checked={
                              JSON.parse(
                                localStorage.getItem("step8-back-data")
                              ) &&
                              JSON.parse(
                                localStorage.getItem("step8-back-data")
                              ) == 1
                            }
                          />
                          <span className="checkmark"></span>
                          <span> خیر، وبسایت برای کسب‌وکار من مفید نیست.</span>
                        </label>
                      </div>
                      <label
                        className="container-rbtn-s1 rbtn-s6"
                        onChange={handleChange}
                      >
                        <input
                          type="radio"
                          name="radio"
                          value="2"
                          checked={
                            JSON.parse(
                              localStorage.getItem("step8-back-data")
                            ) &&
                            JSON.parse(
                              localStorage.getItem("step8-back-data")
                            ) == 2
                          }
                        />
                        <span className="checkmark"></span>خیر، در حال حاضر
                        وبسایت دارم.
                      </label>
                      <label
                        className="container-rbtn-s1 rbtn-s6"
                        onChange={handleChange}
                      >
                        <input
                          type="radio"
                          name="radio"
                          value="3"
                          checked={
                            JSON.parse(
                              localStorage.getItem("step8-back-data")
                            ) &&
                            JSON.parse(
                              localStorage.getItem("step8-back-data")
                            ) == 3
                          }
                        />
                        <span className="checkmark"></span>
                        بله به طراحی وبسایت نیاز دارم.{" "}
                        <span className="s6-small">(غیر رایگان) </span>
                      </label>
                    </div>

                    <div className="rb-steps-btns-s8">
                      <Link
                        to="/register-business-step7"
                        className="rb-steps-btn1 hov-shadow"
                      >
                        مرحله قبلی
                      </Link>
                      <MDBBtn
                        disabled={disable}
                        className="rb-steps-btn2 rb-step6-btn hov-shadow"
                        onClick={submitHandler}
                      >
                        ثبت درخواست
                      </MDBBtn>
                    </div>
                  </div>
                )}
              </div>
              <div className="col-12 col-md-4 px-0 text-center d-md-block d-none">
                <img
                  className="register-business-img"
                  src={imgg}
                  alt="register business"
                />
              </div>
            </MDBRow>
          </div>
        </>
      ) : (
        <></>
      )}

      <MDBModal tabIndex="-1" show={centredModal} setShow={setCentredModal}>
        <MDBModalDialog centered className="justify-content-center">
          <MDBModalContent className="costum_modal">
            <div className="reletive_profile">
              <MDBBtn
                className="btn-close close_modal"
                color="none"
                onClick={toggleShow}
              ></MDBBtn>
            </div>
            <div>
              <p className="text_modal pe-3 ps-4 me-n2 mt-3 pt-3">
                اطلاعات شما با موفقیت ثبت شد.
                <br />
                تیم گیشنیز به زودی با شما تماس خواهد گرفت.
              </p>
            </div>
            <div className="a_s_c">
              <button
                onClick={() => {
                  toggleShow();
                }}
                className="button_modal"
              >
                تایید
              </button>
            </div>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
};

export default RegisterBusinessStep6;
